import React, { useState } from 'react';
import PropTypes from 'prop-types';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { Switch, ToggleSwitch } from './Input.js';
export function SwitchInput(props){
    const [switchStatus,setSwitchStatus] = useState(props.state ? props.state : false)
    const [label,setLabel] = useState(props.label ? props.label : "Label Required")
    return (
        <div className="switch-container flex f-row f-ac">
            {
                !props.hiddenLabel && <p class='bold'>{label}</p>  
            }
            <ToggleSwitch state={switchStatus} stateChanged={(state) => props.stateUpdated(state)}/>
        </div>
    )
}